<template>
  <v-layout row justify-center>
    <v-dialog v-model="component.destroyDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"
          >Deseja Excluir este item de Produtos ?</v-card-title
        >
        <v-card-text>Essa ação irá excluir o item de Produtos</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="
              () => {
                executeAlterDestroyDialog();
              }
            "
            >Cancelar</v-btn
          >
          <v-btn
            color="success ml-4"
            @click="
              () => {
                submit();
              }
            "
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { DESTROY_PRODUCT } from "../../../store/actions/product";
export default {
  props: {
    component: Object,
    destroy_object: Object,
  },
  methods: {
    executeAlterDestroyDialog() {
      this.component.destroyDialog = !this.component.destroyDialog;
    },
    async submit() {
      let id = this.destroy_object.id;
      try {
        await this.$store.dispatch(DESTROY_PRODUCT, id);
      } catch (error) {
        console.log(error);
      } finally {
        this.executeAlterDestroyDialog();
      }
    },
  },
};
</script>

<style>
</style>